import script from "./FirstAidKit.vue?vue&type=script&setup=true&lang=js"
export * from "./FirstAidKit.vue?vue&type=script&setup=true&lang=js"

import "./FirstAidKit.vue?vue&type=style&index=0&id=1cf7b1c9&lang=css"

const __exports__ = script;

export default __exports__